/**
 * Глобальный API для уведомлений в WebSocket handlers
 * 
 * WebSocket handlers работают вне React контекста, поэтому нельзя использовать App.useApp()
 * Этот модуль предоставляет глобальный API который инициализируется в App компоненте
 */

import type { NotificationInstance } from 'antd/es/notification/interface';
import type { MessageInstance } from 'antd/es/message/interface';

interface NotificationApi {
  notification: NotificationInstance | null;
  message: MessageInstance | null;
}

let globalNotificationApi: NotificationApi = {
  notification: null,
  message: null,
};

/**
 * Инициализирует глобальный notification API
 * Должен вызываться в App компоненте после App.useApp()
 */
export function initWebSocketNotificationApi(
  notification: NotificationInstance,
  message: MessageInstance,
): void {
  globalNotificationApi = { notification, message };
}

/**
 * Получить глобальный notification API
 */
export function getWebSocketNotificationApi(): NotificationApi {
  return globalNotificationApi;
}

/**
 * Показать notification через WebSocket API
 */
export function showWebSocketNotification(
  type: 'success' | 'error' | 'info' | 'warning',
  content: string,
  title?: string,
  duration?: number,
): void {
  const { notification, message } = globalNotificationApi;

  if (!notification && !message) {
    // Fallback на console если API не инициализирован
    console.log(`[WebSocket ${type}] ${title ? `${title}: ` : ''}${content}`);
    return;
  }

  // Используем notification для более информативных сообщений
  if (notification && title) {
    notification[type]({
      message: title,
      description: content,
      duration: duration ?? 4.5,
      placement: 'bottomRight',
    });
  } else if (message) {
    // Fallback на message для простых уведомлений
    message[type](content, duration ?? 3);
  }
}
